module.exports = __webpack_public_path__ + "img/pesa logo.4122a20b.jpg";